import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68416a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "detail" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" © Klook travel 2014 - 2023 All rights reserved. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_klook_icon = _resolveComponent("klook-icon")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "vefify-token" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "klook-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_klook_icon, {
            class: "klook-logo",
            type: 'logo',
            size: [152, 24]
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "klook-conetent" }, {
        default: _withCtx(() => [
          (_ctx.status === 'loading')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_loading_outlined, { style: { fontSize: '64px' } }),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('76175')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.status === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_klook_icon, {
                  type: "success",
                  size: 64
                }),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.tokenInfo.token_type === 'active' ? _ctx.$t('75626') : _ctx.$t('76184')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.verifyDes), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.status === 'fail')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_klook_icon, {
                  type: "fail",
                  size: 64
                }),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('76176')), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.verifyDes), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, { class: "klook-footer" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}